import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Add_client from "./Add_client";
import Edit_client from "./Edit_client";
import { API_BASE_URL } from "../../api";

const Client_Comp = () => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [activeTab, setActiveTab] = useState("card");
  const [loading, setLoading] = useState(true); // New loading state

  // Fetch clients from the API on mount
  useEffect(() => {
    const fetchClients = async () => {
      const authToken = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      if (!authToken || !userId) {
        Swal.fire("Error", "Authentication required. Please log in.", "error");
        window.location.href = "/"; // Redirect to the login page
        return;
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/api/client`, {
          headers: {
            authorization: `Bearer ${authToken}`,
            user_id: userId,
          },
        });
        setClients(response.data);
        setFilteredClients(response.data);
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching clients:", error);
        setLoading(false); // Set loading to false in case of an error
        Swal.fire("Error", "Failed to fetch clients. Please try again.", "error");
      }
    };

    fetchClients();
  }, []);

  // Handle search query updates
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = clients.filter((client) =>
      [
        client.full_name,
        client.mobile_no,
        client.location,
        client.city,
        client.company_name,
        client.email_id,
      ]
        .filter(Boolean) // Prevent errors from null values
        .some((field) => field.toLowerCase().includes(query))
    );
    setFilteredClients(filtered);
  };

  // Handle edit button click
  const handleEditClick = (client) => {
    setSelectedClient(client);
  };

  // Handle delete button click
  const handleDeleteClick = (clientId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_BASE_URL}/api/client/${clientId}`, {
            headers: {
              authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          })
          .then(() => {
            const updatedClients = clients.filter((client) => client.id !== clientId);
            setClients(updatedClients);
            setFilteredClients(updatedClients);
            Swal.fire("Deleted!", "Client successfully deleted.", "success");
          })
          .catch((error) => {
            console.error("Error deleting client:", error);
            Swal.fire("Error", "Failed to delete the client.", "error");
          });
      }
    });
  };

  const toCamelCase = (str) => {
    const camelCased = str.replace(/_([a-z])/g, (match, group1) => group1.toUpperCase());
    return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
  };


  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    setCurrentPage(1);
  }, [search,itemsPerPage]);

  const filteredData = clients.filter((client) =>
    [
      client.full_name,
      client.mobile_no,
      client.location,
      client.city,
      client.company_name,
      client.email_id,
    ]
      .filter(Boolean) // Prevent errors from null values
      .some((field) => field.toString().toLowerCase().includes(search))
  );


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + parseInt(itemsPerPage));
  // console.log(startIndex);
  // console.log(startIndex + parseInt(itemsPerPage));


  // Skeleton loading UI
  const renderSkeleton = () => {
    return (
      <div className="col-xl-3 col-lg-4 col-md-6">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div className="skeleton skeleton-loader skeleton-circle"></div>
            </div>
            <div className="text-center mb-3">
              <div className="skeleton skeleton-loader skeleton-loader skeleton-text skeleton-heading"></div>
              <div className="skeleton skeleton-loader skeleton-badge"></div>
            </div>
            <div>
              <div className="skeleton skeleton-loader skeleton-text"></div>
              <div className="skeleton skeleton-loader skeleton-text"></div>
            </div>
            <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
              <div className="skeleton skeleton-loader skeleton-text"></div>
              <div className="skeleton skeleton-loader skeleton-text"></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="content">
      {/* Breadcrumb */}
      <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <div className="my-auto mb-2 text-start">
          <div className="pagetitle">
            <h1>Client</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <li className="breadcrumb-item" href="javascript:void(0)">
                    Home
                  </li>
                </li>
                <li className="breadcrumb-item">Client</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div className="me-2 mb-2">
            <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
              <ul className="nav nav-tabs">
                <li className="">
                  <button
                    className={`nav-link ${activeTab === "card" ? "active" : ""}`}
                    onClick={() => setActiveTab("card")}
                  >
                    <i className="fa fa-th"></i>
                  </button>
                </li>
                <li className="">
                  <button
                    className={`nav-link ${activeTab === "table" ? "active" : ""} `}
                    onClick={() => setActiveTab("table")}
                  >
                    <i className="fa fa-list"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="mb-2">
            <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#add_client"
              className="btn btn-primary d-flex align-items-center"
            >
              <i className="fa fa-plus-circle me-2"></i>Add Client
            </a>
          </div>
        </div>
      </div>

      {/* Client Statistics */}
      <div className="row">
        <div className="col-xl-3 col-md-6 d-flex">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0 me-2">
                    <span className="p-2 br-10  border border-pink d-flex align-items-center justify-content-center">
                      <i className="fa fa-users  fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p className="fs-12 fw-medium  text-gray-5 mb-1">Total Clients</p>
                    <h4>{filteredClients.length}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Client Cards */}
      {activeTab === "card" ? (
        <div>
          {/* Search Bar */}
          <div className="card mb-3">
            <div className="card-body">
              <input
                type="text"
                className="form-control"
                placeholder="Search clients by name, phone, location, etc."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="row">
            {loading
              ? Array.from({ length: 4 }).map((_, index) => renderSkeleton()) // Render skeletons while loading
              : filteredClients.length > 0
                ? filteredClients.map((client) => (
                  <div key={client.id} className="col-xl-3 col-lg-4 col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div></div>
                          <div className="dropdown">
                            <button
                              className="btn btn-icon btn-sm rounded-circle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="fa fa-ellipsis-v"></i>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end p-3">
                              <li>
                                <a
                                  className="dropdown-item rounded-1"
                                  href="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_client"
                                  onClick={() => handleEditClick(client)}
                                >
                                  <i className="ti ti-edit me-1"></i>Edit
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item rounded-1"
                                  href="#"
                                  onClick={() => handleDeleteClick(client.id)}
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="text-center mb-3">
                          <h6 className="mb-1">{toCamelCase(client.full_name)}</h6>
                          <span className="badge bg-primary fs-10 fw-medium border-none">
                            {client.mobile_no}
                          </span>
                        </div>
                        <div>
                          <p className="mb-2 text-truncate">Location: <span>{toCamelCase(client.location)}</span></p>
                          <p className="mb-2 text-truncate">City: <span>{toCamelCase(client.city)}</span></p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
                          <div className="ellips_1">
                            <p className="mb-1 fs-12 ">Company</p>
                            <h6 className="fw-normal text-truncate" title={`${client.company_name}`}>{toCamelCase(client.company_name)}</h6>
                          </div>
                          <div className="email ellips_1">
                            <p className="mb-1 fs-12">Email</p>
                            <a href={`mailto:${client.email_id}`}>
                              <h6 className="fw-normal text-truncate ellips_1" title={`${client.email_id}`}>{client.email_id}</h6>

                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                : "No clients found."}
          </div>
        </div>
      ) : (
        <div className="table-responsive custom-datatable-filter">
          <div className="row mt-2 justify-content-between mb-3">
            <div className="d-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
              <label htmlFor="dt-length-0"> entries per page</label>
              <select aria-controls="datatable" className="form-select form-select-sm" id="dt-length-0" value={itemsPerPage}
                onChange={(e) => setItemsPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className="d-md-flex justify-content-between align-items-center dt-layout-end col-md-auto ms-auto">
              <label htmlFor="dt-search-0" className="form-label me-2 visually-hidden">Search:</label>
              <input
                type="text"
                placeholder="Search..."
                className="p-2 border rounded mb-4 w-full"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <table className="table table-bordered dataTable" id="datatable">
            <thead>
              <tr>
                <th>Actions</th>
                <th>S. No.</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Location</th>
                <th>City</th>
                <th>Company</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((client, index) => (

                <tr key={client.id}>
                  <td>
                    <a
                      className=""
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_client"
                      onClick={() => handleEditClick(client)}
                    >
                      <i className="fas fa-edit text-success ms-3"></i>
                    </a>
                    <button
                      className=""
                      onClick={() => handleDeleteClick(client.id)}
                    >

                      <i className="fas fa-trash text-primary ms-3"></i>
                    </button>
                  </td>
                  <td> {((currentPage - 1) * itemsPerPage) + (index + 1)}</td>
                  <td>{toCamelCase(client.full_name)}</td>
                  <td>{client.mobile_no}</td>
                  <td>{toCamelCase(client.location)}</td>
                  <td>{toCamelCase(client.city)}</td>
                  <td>{toCamelCase(client.company_name)}</td>
                  <td>{client.email_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-center mt-4">
            <button
              className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span className="px-3 py-1">Page {currentPage} of {totalPages}</span>
            <button
              className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>

        </div>
      )}

      {/* Modals */}
      <Add_client />
      <Edit_client
        client={selectedClient}
        onClientUpdated={() => {
          setSelectedClient(null);
          // Optionally refetch clients after edit
        }}
      />
    </div>
  );
};

export default Client_Comp;
